module.exports = __webpack_public_path__ + "static/media/visa.d09c959f.svg";